import { FAPlateDTO } from './model/fa-plate-dto';
import { FragmentAnalysis } from './model/fragment-analysis';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Machine } from '../masterdata/models/machine';
import { MessagesService } from '../messages/messages.service';
import { ReadFile, ReadMode, FilePickerDirective } from 'ngx-file-helpers';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgsFragmentAnalysisService } from './ngs-fragment-analysis.service';
import { MachineGeneratedFile } from '../ngs-volume-adjustment/machine-generated-file';
import { LiquidLevelDetectionRequest } from '../ngs-volume-adjustment/liquid-level-detection-request';
import { ErrorHandler } from '../utils/error-handler';
import { saveAs as saveByFileSaver } from "file-saver";
import { NGSWorkfileResponse } from '../ngs-volume-adjustment/ngs-workfile-response';
import { DatePipe } from '@angular/common';
import { SelectableLab } from '../masterdata/models/lab';
import { Carrier } from '../carrier/carrier';
import { FAWorkFileGenerationRequest } from './model/fa-workfile-request';

@Component({
  selector: 'app-ngs-fragment-analysis',
  templateUrl: './ngs-fragment-analysis.component.html',
  styleUrls: ['./ngs-fragment-analysis.component.css'],
  providers: [DatePipe]
})
export class NgsFragmentAnalysisComponent implements OnInit {

  createdBy: string;
  machineBarcode: string;

  errorHandler: ErrorHandler = new ErrorHandler;
  selectedLab: SelectableLab;

  readMode = ReadMode.Text;
  lrsFileName: string;
  lrsFileContent: string;
  status: string;

  faPlateBarcode: string;

  //Machine Type to generate workfile
  selectedMachineType: string;
  selectedAssayType: string;
  dropdownAssayType: string = null;

  faPlates: FAPlateDTO[];

  fragmentAnalysisRackUnique: FragmentAnalysis[];
  fragmentAnalysisArray: FragmentAnalysis[];
  fragmentAnalysisRack1: FragmentAnalysis[];
  fragmentAnalysisRack2: FragmentAnalysis[];
  fragmentAnalysisRack3: FragmentAnalysis[];

  fragmentAnalysisHSL: FragmentAnalysis[];
  fragmentAnalysisHSN: FragmentAnalysis[];
  fragmentAnalysisSSN: FragmentAnalysis[];
  fragmentAnalysisNOAssay: FragmentAnalysis[];
  genericFAList: FragmentAnalysis[];
  ngsWorkfileRespose: NGSWorkfileResponse = new NGSWorkfileResponse();
  listAssayType: string[];

  changedFragmentAnalysis: FragmentAnalysis[];

  cat_a1: number = 0;
  cat_b1: number = 0;
  cat_c1: number = 0;
  totalNoOfSampleForHS_Large: number = 0;

  cat_a2: number = 0;
  cat_b2: number = 0;
  cat_c2: number = 0;
  totalNoOfSampleForHS_NGS: number = 0;

  cat_b3: number = 0;
  cat_c3: number = 0;
  totalNoOfSampleForSS_NGS: number = 0;


  carriers: Carrier[];


  concentrationDetectionForm: FormGroup;
  generareWorkFileForm: FormGroup

  tableRows: number[];

  @ViewChild('filePicker',{static : false})
  private lrsFilePicker: FilePickerDirective;
  selectableLab: any;
  selectedLabId: string;
  puid: string;

  constructor(private datePipe: DatePipe, private formBuilder: FormBuilder, private ngsFragmentAnalysisService: NgsFragmentAnalysisService,
    private _messagesService: MessagesService) {

    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
    this.puid = localStorage.getItem('PUID');

    this.tableRows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
      14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32];

    this.listAssayType = ['HS_LARGE_FRAGMENT', 'HS_NGS_FRAGMENT', 'SS_NGS_FRAGMENT', 'NO_ASSAY_TYPE'];

    this.concentrationDetectionForm = this.formBuilder.group({
      'createdBy': new FormControl('', Validators.required),
      'machineBarcode': new FormControl('', Validators.required),
      'lrsFileName': new FormControl('', Validators.required)
    });

    this.generareWorkFileForm = this.formBuilder.group({
      'faPlateBarcode': new FormControl('', Validators.required),
      'machineType': new FormControl('', Validators.required)
    });

    this.changedFragmentAnalysis = [];

  }

  onLrsFilePicked(file: ReadFile) {
    this.lrsFileName = file.name;
    this.lrsFileContent = file.content;
  }

  onLrsFileReadEnd(fileCount: number) {
    this.status = `Read ${fileCount} file(s) on ${new Date().toLocaleTimeString()}.`;
    this.lrsFilePicker.reset();
  }

  focusMachinebarcode() {
    document.getElementById('machinbarcode').focus();
  }


  // Change test color if sample concentration value is not valid
  textColor(fragment: FragmentAnalysis): string {
    if (fragment == null)
      return "-";

    let sampleConcentration = (fragment.concentrationValue != null && fragment.concentrationValue != '') ? fragment.concentrationValue : 'NA';
    if (Number.parseFloat(sampleConcentration) === -1.0 || Number.parseFloat(sampleConcentration) === 9999999.0
      || Number.parseFloat(sampleConcentration) === -9999999.0 || sampleConcentration === 'NA') {
      return 'errorValue';
    }
    return 'concentrationOk';
  }


  // Highlight table cell
  private boxHighlighting(sample: FragmentAnalysis): string {

    if (sample == null)
      return "-";

    let assayType = sample.assayType;
    if (assayType === 'HS_LARGE_FRAGMENT') {
      return 'hs_large_fragment';
    } else if (assayType === 'HS_NGS_FRAGMENT') {
      return 'hs_ngs_fragment';
    } else if (assayType === 'SS_NGS_FRAGMENT') {
      return 'ss_ngs_fragment';
    }
  }

  // Upload hemilton file and receive response in FragmentAnalysisReponse
  uploadHemiltonFile() {

    let selectedMachine = new Machine();
    selectedMachine.barcode = this.machineBarcode;
    this.changedFragmentAnalysis = [];

    let hamiltonFile: MachineGeneratedFile = new MachineGeneratedFile(this.lrsFileName, this.lrsFileContent);
    let liquidLevelDetectionRequest: LiquidLevelDetectionRequest =
      new LiquidLevelDetectionRequest(this.selectedLab.lab, hamiltonFile, selectedMachine);

    this.ngsFragmentAnalysisService.uploadHemiltonFile(liquidLevelDetectionRequest).subscribe(
      results => {

        this.resetRacks();
        this.resetWorkFileFormData();

        console.log('Response is : ' + results.data);
        this.fragmentAnalysisArray = results.data;
        //Set active for all samples by default
        this.fragmentAnalysisArray.forEach((fragmentAnalys: FragmentAnalysis) => {
          fragmentAnalys.active = true;
        });

        this.fragmentAnalysisRackUnique = this.fragmentAnalysisArray
          .filter((fragmentAnalys: FragmentAnalysis, i, arr) => {
            return arr.indexOf(arr.find(fa => fa.carrierBarcode === fragmentAnalys.carrierBarcode)) === i;
          });
        this.fragmentAnalysisRack1 = this.fragmentAnalysisArray
          .filter((fragmentAnalys: FragmentAnalysis) => {
            return fragmentAnalys.carrierBarcode === this.fragmentAnalysisRackUnique[0].carrierBarcode;
          });
        this.fragmentAnalysisRack1 = this.getSampleRowPosition(this.fragmentAnalysisRack1);


        this.fragmentAnalysisRack2 = this.fragmentAnalysisArray
          .filter((fragmentAnalys: FragmentAnalysis) => {
            if (this.fragmentAnalysisRackUnique[1] != null && this.fragmentAnalysisRackUnique[1] != undefined)
              return fragmentAnalys.carrierBarcode === this.fragmentAnalysisRackUnique[1].carrierBarcode;
          });
        this.fragmentAnalysisRack2 = this.getSampleRowPosition(this.fragmentAnalysisRack2);


        this.fragmentAnalysisRack3 = this.fragmentAnalysisArray
          .filter((fragmentAnalys: FragmentAnalysis) => {
            if (this.fragmentAnalysisRackUnique[2] != null && this.fragmentAnalysisRackUnique[2] != undefined)
              return fragmentAnalys.carrierBarcode === this.fragmentAnalysisRackUnique[2].carrierBarcode;
          });
        this.fragmentAnalysisRack3 = this.getSampleRowPosition(this.fragmentAnalysisRack3);


        this.loadAssayTypeTable();

        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Upload finished',
          detail: 'Hamilton file has been upload successfully'
        });
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });

      //Get the Available FA Plates with available wells
      this.ngsFragmentAnalysisService.getFAPlateList().subscribe(
        resutls => {
          this.faPlates = resutls.data;
        },
        error => {
          let errMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errMessage);
        }
      );
  }

  //method to refresh the Assay Table data
  loadAssayTypeTable(){
    this.resetCounts();

    this.fragmentAnalysisHSL = this.fragmentAnalysisArray
          .filter((fragmentAnalys: FragmentAnalysis) => {
            return (fragmentAnalys.assayType === 'HS_LARGE_FRAGMENT' && fragmentAnalys.active);
          });

    this.fragmentAnalysisHSN = this.fragmentAnalysisArray
      .filter((fragmentAnalys: FragmentAnalysis) => {
        return (fragmentAnalys.assayType === 'HS_NGS_FRAGMENT'&& fragmentAnalys.active);
      });

    this.fragmentAnalysisSSN = this.fragmentAnalysisArray
      .filter((fragmentAnalys: FragmentAnalysis) => {
        return (fragmentAnalys.assayType === 'SS_NGS_FRAGMENT'&& fragmentAnalys.active);
      });

    this.fragmentAnalysisNOAssay = this.fragmentAnalysisArray
      .filter((fragmentAnalys: FragmentAnalysis) => {
        return (fragmentAnalys.assayType === 'NO_ASSAY_TYPE'&& fragmentAnalys.active);
      });

    console.log("----------------- " + this.fragmentAnalysisHSL.length);

    this.fragmentAnalysisHSL.forEach((fragmentAnalys: FragmentAnalysis) => {
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_A') {
        this.cat_a1++;
        this.totalNoOfSampleForHS_Large++;
      }
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_B') {
        this.cat_b1++;
        this.totalNoOfSampleForHS_Large++;
      }
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_C') {
        this.cat_c1++;
        this.totalNoOfSampleForHS_Large++;
      }
    });

    this.fragmentAnalysisHSN.forEach((fragmentAnalys: FragmentAnalysis) => {
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_A') {
        this.cat_a2++;
        this.totalNoOfSampleForHS_NGS++;
      }
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_B') {
        this.cat_b2++;
        this.totalNoOfSampleForHS_NGS++;
      }
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_C') {
        this.cat_c2++;
        this.totalNoOfSampleForHS_NGS++;
      }
    });

    this.fragmentAnalysisSSN.forEach((fragmentAnalys: FragmentAnalysis) => {
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_B') {
        this.cat_b3++;
        this.totalNoOfSampleForSS_NGS++;
      }
      if (fragmentAnalys.assayTypeCategory === 'CATERGORY_C') {
        this.cat_c3++;
        this.totalNoOfSampleForSS_NGS++;
      }
    });
  }

  // Check if assay type have valid samples, if samples are == 0,
  // disable radio button for assay type selection
  selectAssayTypeBtnDisabled(totalNoOfSamples: number) {
    if (totalNoOfSamples == 0)
      return true;
    return false;
  }

  // On Assay type selection
  selectAssayType(assayType: string) {
    console.log("assayType ---> ", assayType);
    if (assayType != null) {
      this.selectedAssayType = assayType;
    }
  }

  // On Machine type changes
  onMachineTypeChange(machineType: string) {
    console.log('machineType---> : ' + machineType);
    if (machineType != null) {
      this.selectedMachineType = machineType;
    }
  }

  //Validate all the field before submitting the form
  generateWorkFile() {

    console.log("Generate work file....");
    console.log("this.selectedAssayType --> " + this.selectedAssayType);
    console.log("this.selectedMachineType --> " + this.selectedMachineType);
    console.log("this.faPlateBarcode --> " + this.faPlateBarcode);
    let barcodes = [];
    if ((this.faPlateBarcode == "" || this.faPlateBarcode == null || this.faPlateBarcode == undefined) ||
      (this.selectedAssayType == "" || this.selectedAssayType == null || this.selectedAssayType == undefined) ||
      (this.selectedMachineType == "" || this.selectedMachineType == null || this.selectedMachineType == undefined)) {

      let invalidForDataError = {
        severity: 'error',
        summary: 'Invalid Data',
        detail: 'Invalid AssayType or MachineType or FA plate barcode'
      }
      this._messagesService.addErrorMessage(invalidForDataError);
      return;
    }


    if (this.selectedAssayType == 'HS_LARGE_FRAGMENT') {
      this.fragmentAnalysisHSL.forEach(faHSL => {
        barcodes.push(faHSL.sampleBarcode);
        faHSL.plateBarcode = this.faPlateBarcode;
        faHSL.machineType = this.selectedMachineType;
        faHSL.labId = this.selectedLab.lab._id;
      });
      this.genericFAList = this.fragmentAnalysisHSL;
      console.log("Generate work file --> HS_LARGE_FRAGMENT : " + this.fragmentAnalysisHSL);
    }
    else if (this.selectedAssayType == 'HS_NGS_FRAGMENT') {
      this.fragmentAnalysisHSN.forEach(faHSN => {
        barcodes.push(faHSN.sampleBarcode);
        faHSN.plateBarcode = this.faPlateBarcode;
        faHSN.machineType = this.selectedMachineType;
        faHSN.labId = this.selectedLab.lab._id;
      });
      this.genericFAList = this.fragmentAnalysisHSN;
      console.log("Generate work file --> HS_NGS_FRAGMENT : " + this.fragmentAnalysisHSN);
    }
    else if (this.selectedAssayType == 'SS_NGS_FRAGMENT') {
      this.fragmentAnalysisSSN.forEach(faSSN => {
        barcodes.push(faSSN.sampleBarcode);
        faSSN.plateBarcode = this.faPlateBarcode;
        faSSN.machineType = this.selectedMachineType;
        faSSN.labId = this.selectedLab.lab._id;
      });
      this.genericFAList = this.fragmentAnalysisSSN;
      console.log("Generate work file --> SS_NGS_FRAGMENT : " + this.fragmentAnalysisSSN);
    }

    var currentDate = new Date();
    var dateValue  = this.datePipe.transform(currentDate, 'yy-MM-dd HH:mm');
    var str1 = dateValue.toString().replace(/-/g,'');
    var str2 = str1.toString().replace(/:/g,'');
    var filePrefix = str2.toString().replace(' ','_');
    let fileCsv: string = filePrefix + '_Fill_in_FA.csv';
    let fileTxt: string = filePrefix + '_FA_EQC.txt';

    console.log("Generate work file....API Call.....");
    //Call backend API to generate workfile
    let faWorkfileRequest: FAWorkFileGenerationRequest = new FAWorkFileGenerationRequest();
    faWorkfileRequest.faRequest = this.genericFAList;
    faWorkfileRequest.labId = this.selectedLabId;
    faWorkfileRequest.userId = this.puid;
    faWorkfileRequest.workfileName = fileTxt;
    this.ngsFragmentAnalysisService.getSampleMeasurementIdmap(barcodes, this.selectedLabId).subscribe(
      result => {
        faWorkfileRequest.barcodeMeasurementIdMap = result.data;
        this.downloadFAFiles(faWorkfileRequest, fileCsv, fileTxt);
      },
      error => {
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      }
    );
  }

  private downloadFAFiles(faWorkfileRequest: FAWorkFileGenerationRequest, fileCsv: string, fileTxt: string) {
    this.ngsFragmentAnalysisService.generateFAWorkfiles(faWorkfileRequest).subscribe(
      results => {
        this.faPlateBarcode = '';
        console.log('Response is:' + results.data);
        this.ngsWorkfileRespose = results.data;
        let csvData = this.ngsWorkfileRespose.csvWorkfile;
        let blobCsv: Blob = new Blob([csvData], { type: 'text/plain' });
        saveByFileSaver(blobCsv, fileCsv);

        let txtData = this.ngsWorkfileRespose.txtDataFile;
        let blobTxt: Blob = new Blob([txtData], { type: 'text/plain' });
        saveByFileSaver(blobTxt, fileTxt);

        //Get the Available FA Plates with available wells
        this.ngsFragmentAnalysisService.getFAPlateList().subscribe(
          resutls => {
            this.faPlates = resutls.data;
          },
          error => {
            let errMessage = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(errMessage);
          }
        );
      },
      error => {
        console.log(error);
        const errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });
  }

  //Reset Racks
  resetRacks() {
    console.log("Reseting racks.....");
    this.fragmentAnalysisRack1 = [];
    this.fragmentAnalysisRack2 = [];
    this.fragmentAnalysisRack3 = [];
  }

  //Reset Count
  resetCounts() {
    console.log("Reseting count.....");

    this.fragmentAnalysisHSL = [];
    this.fragmentAnalysisHSN = [];
    this.fragmentAnalysisSSN = [];

    this.totalNoOfSampleForHS_Large = 0;
    this.totalNoOfSampleForHS_NGS = 0;
    this.totalNoOfSampleForSS_NGS = 0;

    this.cat_a1 = 0;
    this.cat_b1 = 0;
    this.cat_c1 = 0;

    this.cat_a2 = 0;
    this.cat_b2 = 0;
    this.cat_c2 = 0;

    this.cat_b3 = 0;
    this.cat_c3 = 0;
  }

  // Reset all field
  resetWorkFileFormData() {
    this.faPlateBarcode = "";
  }


  // Method to round of decimal digits of measured volume
  roundOfDecimal(num: number) {
    if (num != null) {
      if (num === -9999999) {
        return '<0.00';
      } else if (num === 9999999) {
        return '>105.00';
      } else if (num === -1) {
        return '?????';
      }
      return Math.round(num * 100) / 100;
    }

  }

  //Check the validity of Sample
  isBarcodeFound(fragmentAnalysis: FragmentAnalysis) {
    if (fragmentAnalysis == null || fragmentAnalysis == undefined) {
      return false;
    } else {
      if ((fragmentAnalysis.assayType == null || fragmentAnalysis.assayType == '' || fragmentAnalysis.assayType == undefined)
        && (fragmentAnalysis.concentrationValue == null || fragmentAnalysis.concentrationValue == '' || fragmentAnalysis.concentrationValue == undefined)) {
        return false;
      }
      return true;
    }
  }

  //get Sample position on the rack
  getSampleRowPosition(fragmentAnalysis: FragmentAnalysis[]) {
    let fragmentAnalysisNew: FragmentAnalysis[] = [];

    if (fragmentAnalysis != null && fragmentAnalysis != undefined) {
    let count = 0;
      for (let index = 0; index < fragmentAnalysis.length; index++) {
        let temp = fragmentAnalysis[index];
        if (temp != null) {
          while (temp.positionRow - 1 > count) {
            fragmentAnalysisNew[count] = new FragmentAnalysis();
            count++;
          }
          fragmentAnalysisNew[count] = temp;
        }
        count++;
        if(count > 31) break;
      }
    }
    return fragmentAnalysisNew;
  }

   /**
     *
     * Disable the Barcode, when it is inactive
     */
    isSampleActive(fragmentAnalysis: FragmentAnalysis) {
      if (fragmentAnalysis == null || fragmentAnalysis == undefined) {
        return false;
      } else {
        if ((!fragmentAnalysis.active)) {
          return false;
        }
        return true;
      }
    }

    //Get Assasy type of the sample
    getAssayTypeforSample(fragmentAnalysis: FragmentAnalysis){
      if (fragmentAnalysis != null || fragmentAnalysis != undefined) {
        return fragmentAnalysis.assayType;
      }
      return null;
    }

    //Disable the Options depending on Asstype Options
    disableAssayTypeOptions(fragmentAnalysis: FragmentAnalysis, assayType:string):boolean{
      //disable SS_NGS_FRAGMENT option always
      if (assayType == 'SS_NGS_FRAGMENT') {
        return true;
      }
      //disable NO_ASSAY_TYPE option always
      else if(assayType == 'NO_ASSAY_TYPE'){
        return true;
      }
      //enable HS_LARGE_FRAGMENT option always
      else if(assayType == 'HS_LARGE_FRAGMENT'){
        return false;
      }
      //disable HS_NGS_FRAGMENT incase of NO_ASSAY_TYPE
      else if(assayType == 'HS_NGS_FRAGMENT' && fragmentAnalysis != null && fragmentAnalysis.assayType == 'NO_ASSAY_TYPE'){
          return true;
      }
      //enable HS_NGS_FRAGMENT for other assay types 
      else{
        return false;
      }
    }

    //Set the changed Assay type to sample
    onAssayTypeChange(fragmentAnalysis: FragmentAnalysis, newAssayType:string){
      if (fragmentAnalysis != null || fragmentAnalysis != undefined) {
          fragmentAnalysis.assayType = newAssayType;
          this.changedFragmentAnalysis.forEach(sample => {
            if(sample.sampleBarcode === fragmentAnalysis.sampleBarcode) {
              this.changedFragmentAnalysis.splice(this.changedFragmentAnalysis.indexOf(sample), 1);
            }
          });
          this.changedFragmentAnalysis.push(fragmentAnalysis);
      }
    }

    //Method enable or disable the sample
    onCheckBoxClick(event, fragmentAnalysis: FragmentAnalysis) {
      var sampleBarcode: string = fragmentAnalysis.sampleBarcode;

      if (event.target.checked) {
        this.fragmentAnalysisArray.forEach((fragmentAnalys: FragmentAnalysis) => {
          if(fragmentAnalys.sampleBarcode == sampleBarcode){
            fragmentAnalys.active = false;
          }
        });
      } else {
        this.fragmentAnalysisArray.forEach((fragmentAnalys: FragmentAnalysis) => {
          if(fragmentAnalys.sampleBarcode == sampleBarcode){
            fragmentAnalys.active = true;
          }
        });
      }
    }

    refreshAssyTypeTable() {
      this.ngsFragmentAnalysisService.updateSampleAssayType(this.changedFragmentAnalysis).subscribe(
        results => {
          let index;
          this.changedFragmentAnalysis = [];
          if(results.data) {
            let changedFA: FragmentAnalysis[] = results.data;
            changedFA.forEach( incomingSample => {
              this.fragmentAnalysisArray.forEach(sample => {
                if(sample.sampleBarcode === incomingSample.sampleBarcode) {
                  sample.assayType = incomingSample.assayType;
                  sample.assayTypeCategory = incomingSample.assayTypeCategory;
                }
              });
            });
          }
          this.loadAssayTypeTable();
        },
        error => {
          let errMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errMessage);
      }
    );
  }
}
